import { formatStringAsPhoneNumber } from 'helpers/formatStringAsPhoneNumber';

export const retirablePhoneNumber = '18332221807';

export const formattedRetirablePhoneNumber = formatStringAsPhoneNumber(
  retirablePhoneNumber,
);
